import simpleParallax from 'simple-parallax-js';

$(document).ready(function () {
    var image = document.querySelector('.illu-intro .parallax');
    new simpleParallax(image, {overflow: true });

    $('body').addClass('loaded');

    var introEl = $('.home-intro');
    var introSquare = $('.home-intro .square-container');
    introSquare.css('transform', `translateY(0px)`);
    var introTable = $('.illu-intro #table');
    var introComputer = $('.illu-intro #Computer');
    var introBoard = $('.illu-intro #board');

    $(window).on('scroll resize', function () {
        var scroll = Math.min((window.scrollY / introEl.height()), 1);

        var tablePosition = (-scroll * 18);
        introTable.css('transform', `translateY(${tablePosition}px)`);
        introComputer.css('transform', `translateY(${tablePosition}px)`);
        introBoard.css('transform', `translateY(${-tablePosition}px)`);
        introSquare.css('transform', `translateY(${(-window.scrollY * 1.02)}px)`);
    });
});
